var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myDoctor"},[_c('div',{staticClass:"navigator border-1px"},[_c('router-link',{attrs:{"tag":"div","to":"/myDoctor/recentChat"}},[_vm._v("最近消息")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"div","to":"/myDoctor/followDoctor"}},[_vm._v("关注医生")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-960cca9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/service/myDoctor.vue
// module id = 1351
// module chunks = 382